import { openBlock as a, createElementBlock as r, normalizeClass as o, createBlock as c, withCtx as i, createVNode as d, createCommentVNode as n, toDisplayString as l } from "vue";
import m from "../../atoms/icon/icon.vue.js";
import s from "../../atoms/icon/icon-frame.vue.js";
import { themeProp as y } from "../../composables/useTheme.js";
/* empty css             */
import u from "../../_virtual/_plugin-vue_export-helper.js";
const b = "DsEyebrow", f = /* @__PURE__ */ Object.assign({
  name: b
}, {
  __name: "eyebrow",
  props: {
    ...y,
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: [Object, null],
      default: null,
      validator: (e) => ["name", "category"].every((t) => t in e)
    },
    hasOuterPadding: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, x) => e.icon || e.text ? (a(), r("div", {
      key: 0,
      class: o(["ds-eyebrow", { "ds-eyebrow__single-element": !(e.text && e.icon), "ds-padding-y-12": e.hasOuterPadding }]),
      "data-j-eyebrow": ""
    }, [
      e.icon ? (a(), c(s, {
        key: 0,
        class: o(["ds-eyebrow__icon", { "ds-eyebrow__icon--only": !e.text }]),
        size: "24",
        "align-y": "center"
      }, {
        default: i(() => [
          d(m, {
            name: e.icon.name,
            category: e.icon.category,
            "data-j-icon": ""
          }, null, 8, ["name", "category"])
        ]),
        _: 1
      }, 8, ["class"])) : n("", !0),
      e.text ? (a(), r("p", {
        key: 1,
        class: o(["ds-eyebrow__text", [`ds-eyebrow__text--${t.theme}`, "ds-text"]]),
        "data-j-text": ""
      }, l(e.text), 3)) : n("", !0)
    ], 2)) : n("", !0);
  }
}), v = /* @__PURE__ */ u(f, [["__scopeId", "data-v-fab41643"]]);
export {
  v as default
};
